<template lang="html">
  <div class="mng-editor-content">
    <div class="mng-editor-panel">
      <div class="mng-editor-panel__block">
        <div>
          关键帧管理
        </div>
        <div class ="editor-panel-labelbutton">
          <span>前端显示</span>
          <el-switch v-model="viewEditable" />
        </div>
      </div>
      <div class="mng-editor-panel__block mng-editor-panel__block--last">
        <div class="editor-panel-list">
          <div class="editor-panel-list__title">
            <span>帧序列</span>
            <span>点位</span>
            <span>操作</span>
          </div>
          <div ref="listcontainer" class="editor-panel-list__items">
            <div v-for="(item, index) in roamlist" :key="index" 
              class="editor-panel-list__item"
              :class="{'editor-panel-list--active':item.selected}"
              @click="click(item)">
              <span>{{ item.id }}</span>
              <span>{{ item.panoramaId }}</span>
              <div class="editor-panel-list__actions">
                <div class="ai-button ai-button--text ai-button--text--primary"
                     @click.stop="upItem(item)">
                  <span>上移</span>
                </div>
                <div class="ai-button ai-button--text ai-button--text--primary"
                     @click.stop="downItem(item)">
                   <span>下移</span>
                </div>
                <div class="ai-button ai-button--text ai-button--text--danger"
                     @click="showDeleteConfirm(item)">
                  删除
                </div>
              </div>
            </div>
          </div>
        </div>
        <div 
              class="ai-button ai-button--primary mng-vr-scene__button"
              style="min-width: 300px; margin-top: 50px"
              @click="playRoam">
          预览漫游动画
        </div>

        <div 
              class="ai-button ai-button--primary mng-vr-scene__button"
              style="min-width: 300px;"
              @click="saveRoam">
          保存 LIST 数据
        </div>
      </div>
    </div>
    <div class="mng-vr-scene">
      <VrScene ref="vrScene"
               class="mng-vr-scene__stage"
               :scene-id="$route.params.modelId"
               @pano-icon-right-click="onPointClicked"
               @initialized="onInitialized"
               @roam-move="onRoamMove" />
      <transition name="fade" mode="out-in" appear>
        <div class="frame-support">
          <div :style="frameStyle" class="frame-support__frame">
            <div class="frame-support__corner frame-support__corner--topleft" />
            <div class="frame-support__corner frame-support__corner--topright" />
            <div class="frame-support__corner frame-support__corner--bottomleft" />
            <div class="frame-support__corner frame-support__corner--bottomright" />
          </div>
        </div>
      </transition>
      <div class="bottom_actions">
          <div />
          <div />
          <div 
               class="ai-button ai-button--primary mng-vr-scene__button"
               :class="{'ai-button--disabled': !canedit, 'ai-button--disabled--primary': !canedit}"
               style="min-width: 169px;"
               @click="reSavePoint" >
           更新关键帧
          </div>
          <div 
               class="ai-button ai-button--primary mng-vr-scene__button"
               style="min-width: 169px;"
               @click="addRoamPoint">
            添加关键帧
          </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VrScene from '@/components/ai-vr-scene.vue';

export default {
  components: {
    VrScene
  },
  data() {
    return {
      nowselect: null,
      items: [],
      roamlist: [],
      pointEditable: false,
      viewEditable: false,
      frameStyle: {
        height: 0,
        width: 0
      },
      canedit: false
    };
  },
  mounted() {
    // this.loadPanoramaIcons();
    window.addEventListener('resize', this.updateFrame);
    this.updateFrame();
  },
  beforeDestroy() {
    // do something before destroying vue instance
    window.removeEventListener('resize', this.updateFrame);
  },
  methods: {
    onInitialized() {
      this.getData();
    },
    async getData(){
      try {
        const { data: { data } } = await this.$http.post(
          '/animation/fetch',
          {
            store_id: this.$route.params.modelId
          }
        );
        this.roamlist = data;
        for(let i = 0;i < this.roamlist.length;i++) {
        
          this.roamlist[i].selected = false;
        }
        //  console.log('-----------------',data);
      } catch (error) {
        this.$log(error);
      }
    },
    updateFrame() {
      const scene = this.$refs.vrScene.$el;
      this.frameStyle = {
        height: `${scene.clientHeight - 16}px`,
        width: `${(scene.clientHeight - 16) * 0.5625}px`
      };
    },
    click(item) {
      if(this.nowselect) {
        this.nowselect.selected = false;
        this.nowselect = item;
      } else 
      {
        this.nowselect = item;
      }
      this.nowselect.selected = true;
      this.$refs.vrScene.moveToRoam(item);
      this.canedit = true;
    },
    upItem(item) {
      if(item.id === 0) return;
      for(let i = 0;i < this.roamlist.length;i++) {
        if(this.roamlist[i].id === item.id)
        {
          const tempid = item.id;
          this.roamlist[i].id = this.roamlist[i-1].id;
          this.roamlist[i-1].id = tempid;
        }
      }
      this.roamlist.sort(function(a,b){
			  return a.id - b.id
      });
    },
    downItem(item) {
      if(item.id === (this.roamlist.length - 1)) return;
       for(let i = 0;i < this.roamlist.length;i++) {
        if(this.roamlist[i].id === item.id)
        {
          const tempid = item.id;
          this.roamlist[i].id = this.roamlist[i+1].id;
          this.roamlist[i+1].id = tempid;
        }
      }
      this.roamlist.sort(function(a,b){
			  return a.id - b.id
		  });
    },
    showDeleteConfirm(id) {
      this.$confirm({
        title: '警 告',
        message: '确认要删除该标签吗?'
      }).then(() => {
        this.deleteLabel(id);
      }).catch(() => {});
    },
    addRoamPoint(){
      const { direction: { x, y, z }, panoramaId } = this.$refs.vrScene.getCurrentView();
      const point = {id:this.roamlist.length,panoramaId:panoramaId,selected:true,position:{ x, y, z }};
      this.roamlist.push(point);
      if(this.nowselect)this.nowselect.selected = false;
      this.nowselect = point;
      this.canedit = true;
      if(this.roamlist.length >=18){
        setTimeout(() => {
            this.$refs.listcontainer.scrollTop = this.$refs.listcontainer.scrollHeight;
        }, 10);        
      } 
    },
    reSavePoint(){
      this.$message('更新成功');
      const { direction: { x, y, z }, panoramaId } = this.$refs.vrScene.getCurrentView();
      this.nowselect.position.x = x;
      this.nowselect.position.y = y;
      this.nowselect.position.z = z;
    },
    playRoam(){
      console.log(this.roamlist);
      this.$refs.vrScene.startRoamList(this.roamlist);
    },
    async saveRoam(){
      try {
          const data = await this.$http.post(
            '/animation/save',
            {
              store_id: this.$route.params.modelId,
              data: this.roamlist
            }
          );
          this.$message.basic({
            message: '保存list成功'
          });
        } catch (error) {
          this.$log(error);
        }
    },
    onRoamMove(roampoint){
      for(let i = 0;i < this.roamlist.length;i++) {
        if(this.roamlist[i].id === roampoint.Id)
        {
          this.roamlist[i].selected = true;
          this.nowselect = this.roamlist[i];
        } else {
          this.roamlist[i].selected = false;
        }
      }
    },
    deleteLabel(item) {
      this.roamlist=this.roamlist.filter((i => i.id!=item.id));
      let i = 0;
      for(let i = 0;i < this.roamlist.length;i++) {
        this.roamlist[i].id = i;
      }
      this.canedit = false;
    },
    onPointEditableChange(editable) {
      if (editable) this.$refs.vrScene.setShowMode('edit');
      else this.$refs.vrScene.setShowMode('normal');
    },
    async loadPanoramaIcons() {
      const { data: { data: { panorama_icons: panoramaIcons } } } = await this.$http.post(
        '/v1/list-brand-panorama-icons',
        { store_id: this.$route.params.modelId }
      );
      this.$refs.vrScene.setPanoramaIcons(panoramaIcons);
    },
    async onPointClicked({ panoramaId, visible }) {
      if (!this.pointEditable) return;
      try {
        await this.$http.post(
          '/admin/modify-panorama?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            // store_id: 1,
            store_id: this.$route.params.modelId,
            panorama_id: panoramaId,
            visible: !visible
          }
        );
        this.$refs.vrScene.setPanoramaVisibility(panoramaId, !visible);
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    },
    async updateInitialView() {
      const { direction: { x, y, z }, panoramaId } = this.$refs.vrScene.getCurrentView();
      try {
        await this.$http.post(
          '/admin/modify-store-initial-view?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          {
            store_id: this.$route.params.modelId,
            panorama_id: panoramaId,
            direction_x: x,
            direction_y: y,
            direction_z: z
          }
        );
        this.$message('修改成功');
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.switch-item {
  display: flex;
  align-items: center;

  span {
    margin-left: 7px;
    font-size: 12px;
    color: #666;
  }
}

.frame-support {
  top: 80px;
  left: 85px;
  width: calc(100% - 170px);
  height: calc(100% - 210px);
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  pointer-events: none;

  &__frame {
    border: 2px dashed #fff;
    position: relative;
  }

  &__corner {
    width: 50px;
    height: 50px;
    position: absolute;

    &--topleft {
      top: -4px;
      left: -4px;
      border-top: 6px solid #fff;
      border-left: 6px solid #fff;
    }

    &--topright {
      top: -4px;
      right: -4px;
      border-top: 6px solid #fff;
      border-right: 6px solid #fff;
    }

    &--bottomleft {
      bottom: -4px;
      left: -4px;
      border-bottom: 6px solid #fff;
      border-left: 6px solid #fff;
    }

    &--bottomright {
      bottom: -4px;
      right: -4px;
      border-bottom: 6px solid #fff;
      border-right: 6px solid #fff;
    }
  }
}

.editor-panel-labelbutton {
  margin-left: 220px;
  font-size: 12px;
}

.bottom_actions{
  width: calc(100% - 170px);
  display: grid;
  grid-template-columns: 15% 15% 40% 15% 15%;
  align-items: center;
  justify-content: center;
}

.editor-panel-list {
  height: 500px;
  border-radius: 4px;
  border: 1px solid #d8d8d8;
  display: flex;
  flex-direction: column;

  &__title {
    display: grid;
    background-color: #e5e5e5;
    grid-template-columns: 20% 40% 40%;
    justify-items: center;
    align-items: center;
    height: 26px;
    font-size: 12px;
    color: #666;
    user-select: none;
  }

  &__items {
    overflow-y: scroll;
    flex: 1;
  }

  &--active {
    background-color: rgb(85, 107, 233);

    span {
      color: rgb(255, 255, 255);
    }
  }

  &__item {
    display: grid;
    grid-template-columns: 20% 40% 40%;
    justify-items: center;
    align-items: center;
    height: 26px;
    font-size: 12px;

    &:last-child {
      border-bottom: 0;
    }
  }

  &__actions .ai-button {
    margin: 0 0px;
  }
}
</style>
